
export const SWITCH_PRODUCT_WAREHOUSE_REFRESH_TABLE = '[ ADDRESSES USERS ACTIONS ] Switch Addresses Users Refresh Table'

export interface ISwitchProductWarehouesRefreshTable {
    type: typeof SWITCH_PRODUCT_WAREHOUSE_REFRESH_TABLE
    payload: boolean
}

